export const LADE_AUSWAHLWERTE_PROZESS = "ladeAuswahlwerteProzess";
